import { render, staticRenderFns } from "./DowntimeMenu.vue?vue&type=template&id=680b2b18&"
import script from "./DowntimeMenu.vue?vue&type=script&lang=ts&"
export * from "./DowntimeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VList})
